import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, Subject, BehaviorSubject, Subscription, of } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CommerrorService } from './commerror.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private cachedCredentials: { user: string; pw: string; location?: string } | null = null;
  // 2FA send-failure UX: the alternate channel to offer (null once every channel has
  // been tried -> the message points at support instead of a button).
  twoFaAlternateMethod: 'sms' | 'whatsapp' | null = null;
  private triedTwoFaMethods = new Set<string>();
  public twoFactorRequired = new Subject<void>();
  public updateInfoRequired = new Subject<void>();
  public isLoginLoading: boolean = false;
  public showTwoFactorInput = false;
  public isArtisanSupport = false;
  public usersList: any[] = [];
  public filteredUserSearch: any[] = [];
  public filteredClinicSearch: [] = [];
  contLogin = false;
  username: string;
  limits;
  public premissions = null;
  totpVerify =false;
  public invasiveExams = false;
  UID;
  GID;
  linksent;
  base64;
  clinicUsers;
  public loggedIn = false;
  loginError: string;
  getCode = false;
  lastAwl:string;
  lastAwlExam:string;
  lastAwlStartDate:any;
  lastAwlEnDate:any;
  export$ = new Subject<any>()
  exportLoading = false;
  ENVLoaded = new Subject<void>();
  pw;
  public category = {
    name: "doctor",
    canOpen: {
      form:true,
      exam:true
    },
    canCreate:{
      form:true,
      exam:true
    },
    canChange:{
      form:true,
      exam:true
    },
    canSend: {
      form:true,
      exam:true
    },
    todayList: true
  };
  public hastech = false;
  public Recording: string;
  public RemoteRTC = false;
  public hasAWL = false;
  public AWLUnlimited = false;
  public bitRate = 500000;
  public highBit = 3000000;
  public AWLOnlyExams = false;
  public onLogin: Subject<void>;
  public onLoginComplete: Subject<void>;
  // Fired with the tab key whenever the exam tab bar switches pages —
  // consumed by AnnouncementHostComponent for trigger:'tab' bubbles.
  public tabChanged$: Subject<string> = new Subject<string>();
  public onFailedLogin: Subject<void>
  public canOpenExams: boolean;
  public fullDelivery: string = 'download';
  public printLang: string = null;
  public printStyle: string = null;
  public userType = 'doctor';
  public summaryOnlyAnamolies = false;
  archiveServer: string;
  loginname:string;
  public printAllMeas = true
  public dopplerAutoOk = true;
  public RequireLoginToOpen = false;
  public anatomyAltNames;
  public hasChameleon = true;
  public hasFollicles=true;
  public defaultsButton = false;
  public links = true;
  public Clinic: string;
  public ClinicID:number;
  public localServer = false;
  public letterhead=false;
  location: string;
  public VideoCodec = 'video/webm;codecs=vp9';
  public clinicOptions;
  public ishospital:any = false;
  public hasLeumit = false;
  public isCardio=false;
  public isGastro=false;
  public isUSG=false;
  public PRNcheck = true;
  public requireExamLogon = true;
  public AWLExamNames = false;
  public hasEmergencyRoom = false;
  public altArchiveName:string = null;
  public CustomHeader = new UntypedFormControl(false)
  picAlt="Header Pic"
  headerToShow;
  isImageLoading = false;
  public altSplashPage;
  public isAdmin= false;
  public finances = false;
  public noneAsMeasDefault = false;
  public LeumitAdmin = false;
  public barcodeScan = false;
  public ExamCodes;
  public hasENV = false;
  public doctor = null;
  public PeerServ: {host: string, port: number, path: string};
  public separatedClinic = false;
  public SeparateZimun = false;
  public deviceType=null
  public isTablet=false
  public license;
  public personalId: string;
  public maccabiExams:any[] = null;
  public linksentSubscription: Subscription;
  public limitsSubscription: Subscription;
  private sessionExpiration = new BehaviorSubject<string>('');
  private sessionExpirationSubscription: Subscription;
  private timeoutId: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private sanitization: DomSanitizer,
    private commerrorService: CommerrorService
  ) {      this.onLogin= new Subject<void>();
      this.onLoginComplete = new Subject<void>();
      this.onFailedLogin = new Subject<void>();
      this.http.get('/api/getenv').subscribe((data)=>{
        let p = {};
        p['env'] = data;
        this.setEnv(p);  
      },(error)=> { 
        console.log(error);
      })
   }

  login(user: string, pw: string, navigate = true, exam = false, isexport = false, code = undefined){
    // Kept so the 2FA verify/resend calls can re-post the same credentials.
    this.cachedCredentials = { user, pw };
    this.twoFaAlternateMethod = null;
    this.triedTwoFaMethods.clear();
    if(! exam){
      if(this.ishospital){
        this.localServer=false;
        let req = this.http.post("/api/login",{"user": user,"pw": pw,"inside": exam,"code": code})
        if(isexport)
          this.followLogin(req,navigate,user, true,pw);
        else
          this.followLogin(req,navigate,user,undefined,pw);
      }
      else{
        this.http.get('http://localhost:8088/alive').subscribe((data)=>{
          if(data['status'] == 'alive')
            this.localServer = true;
            this.http.get('http://localhost:8088/whereami').subscribe((data)=>{
              if(data['office_server']){
                this.ldapLogin(user,pw, data,navigate);
                return;
              }
              if(data['location']){
                // EXTREMELY IMPORTANT, When CONNECTOR Exists, PASS IT TO cachedCreds!
                this.cachedCredentials = { user, pw, location: data['location'] };
                let req = this.http.post("/api/login",{"user": user,"pw": pw,"inside": exam, "location": data['location'],"code": code})
                this.followLogin(req,navigate,user,undefined,pw);
              }
            },(error)=>{
              let req = this.http.post("/api/login",{"user": user,"pw": pw,"inside": exam,"code": code})
              this.followLogin(req,navigate,user,undefined,pw);
              console.log(error);
            });
        }, (error)=>{
          this.localServer=false;
          let req = this.http.post("/api/login",{"user": user,"pw": pw,"inside": exam,"code": code})
          this.followLogin(req,navigate,user,undefined,pw);
        });
      }
    }


  }


  followLogin(req, navigate = true,user=null, isexport = false,pw=null){
    this.clinicOptions = null;
    req.subscribe((data)=>{
      // First login step: the API answers with a state instead of a session when
      // the user still has to update their details or enter a 2FA code.
      if(data && data['state'] === 'requireUpdateInfo'){
        this.updateInfoRequired.next();
        return;
      }
      if(data && data['state'] === 'require_2fa'){
        this.twoFactorRequired.next();
        return;
      }
      // A {status:'fail', error} response (e.g. the 2FA code could not be sent) carries
      // no env/session payload, so setEnv() further down would dereference data.env and
      // throw, aborting before the error is ever displayed. Surface it and stop here.
      if(data && data['status'] == 'fail'){
        if(data['twofaSendFailed'])
          this.handle2FASendFailure(data);
        else
          this.loginError = data['error'] || 'Login failed';
        this.contLogin = false;
        this.onFailedLogin.next();
        return;
      }
      if(data.hasOwnProperty("status") && data["status"] == "ok" && ! data.hasOwnProperty('code')){
        if(isexport){
          this.export$.next(this.exportData())
          return;
        }
        this.Clinic = null;
        if(data['Clinic']){
          this.Clinic = data['Clinic'];
          //try local server
          
        }    
        this.isArtisanSupport = !! data['isArtisanSupport'];
        this.loginError = null;
        this.loginname = user;
        this.pw=pw
        this.UID = data['uid'];
        this.GID=data['GID']
        this.username=data["uname"];
        this.LeumitAdmin = data['HMO'];
        this.totpVerify = data['TOTPSet'];
        this.separatedClinic = false;
        if(data['hasSeparation'])
          this.separatedClinic = true;
        if(data['SeparateZimun'])
          this.SeparateZimun = true;
        else
          this.SeparateZimun=false;
        if(data['maccabi_exams'])
          this.maccabiExams = data['maccabi_exams'];
        else
          this.maccabiExams = null;
        if(data["membership"]){
          switch (data["membership"]) {
            case "forms":
              this.category={
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:false
                },
                canCreate:{
                  form:true,
                  exam:false
                },
                canChange:{
                  form:true,
                  exam:false
                },
                canSend: {
                  form:true,
                  exam:false
                },
                todayList: true
              }
              break;
              case "tech":
                this.category={
                  name: data["category"],
                  canOpen: {
                    form:true,
                    exam:true
                  },
                  canCreate:{
                    form:true,
                    exam:true
                  },
                  canChange:{
                    form:true,
                    exam:true
                  },
                  canSend: {
                    form:true,
                    exam:true
                  },
                  todayList: true
                }
                break;
            case "secretary":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:false,
                  exam:false
                },
                canCreate:{
                  form:false,
                  exam:false
                },
                canChange:{
                  form:false,
                  exam:false
                },
                canSend: {
                  form:false,
                  exam:true
                },
                todayList: true
              }
              break;
            case "nurse":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:false
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;
            case "doctor":
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:true
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;        
            default:
              this.category = {
                name: data["category"],
                canOpen: {
                  form:true,
                  exam:true
                },
                canCreate:{
                  form:true,
                  exam:true
                },
                canChange:{
                  form:true,
                  exam:true
                },
                canSend: {
                  form:true,
                  exam:true
                },
                todayList: true
              }
              break;
          }
        }
        this.getLimits();
        if(data["membership"])
          this.userType = data["membership"];  
        else{//no login
          if(data['env']['requiregroup']){
            this.loginError = "User is not authorized to use this system";
            return;
          }
          this.userType = 'doctor';//otherwise assume doctor
        }
        // this.isAdmin = data['isAdmin'];
        this.isAdmin = data['isAdmin'] || this.userType=='admin'
        this.finances = data['Finances'] || false;
        this.clinicUsers = data['users'];
        this.deviceType=data['deviceType']
        if(this.deviceType=='tablet'){
          this.isTablet=true
        }
        else{
          this.isTablet=false
        }
        this.license=data['license']
        this.personalId=data['personalId']
        

        
        if(this.userType == 'doctor' && this.separatedClinic)
          this.doctor = this.UID;
        this.canOpenExams = data["openExams"];
        if(data['clinics']){
          this.clinicOptions = data['clinics'];
          this.filteredClinicSearch = this.clinicOptions; // add the fliteredOne
        }
        else if(this.isTablet && navigate){
          this.onLogin.next();
          this.router.navigate(['/tablet']); 


        }
        else{
          this.onLogin.next();
          if(navigate)
            this.router.navigate(['/patsearch']);  
        } 
      }
      if(data.hasOwnProperty('letterhead'))
        this.letterhead = data['letterhead'];
      else
        this.letterhead = false;
    this.requireExamLogon = data['requireExamLogon'];
    this.setEnv(data);
    if(data['GID']){
      this.ClinicID = data['GID'];
     
        this.http.get(`/api/login/getTOS`).subscribe((data) => {
          this.premissions = data[0];
          this.onLoginComplete.next();
        });
     
    }
      if(data.hasOwnProperty('code')){
        this.getCode=true;
      }
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
      }
      this.contLogin = false;
    },(error)=>{
      this.loginError = error.error.error;
    });
    return req
  }

  setEnv(data){
    this.ishospital = data['env']['ishospital'];
    if(data["env"]){
      if( data["env"]["recording"]){
        this.Recording = data["env"]["recording"];
        if(data["env"]["webrtc"] == "remote"){
          this.RemoteRTC = true;
          this.PeerServ = data["env"]["peerServer"];
        }
      }
      if(this.ishospital ){
        this.premissions = data["env"]["premissions"]
        this.invasiveExams = this.premissions.ObstetricInvasive;
      }
      if(data['env']['hasTech'])
        this.hastech = data['env']['hasTech'];
      if(data['env']['bitRate'])
        this.bitRate = data['env']['bitRate'];
      if(data['env']['highBitrate'])
        this.highBit = data['env']['highBitrate'];
      if(data["env"]["AWL"])
        this.hasAWL = true;
      if(data["env"].hasOwnProperty("AWLOnlyExamOpening"))
        this.AWLOnlyExams = data["env"]['AWLOnlyExamOpening'];
      if(data["env"]["printLang"])
        this.printLang = data["env"]["printLang"];
      if(data["env"]["printStyle"])
        this.printStyle = data["env"]["printStyle"];
      if(this.ishospital)
        this.RequireLoginToOpen = true;
      else{
        if(data["env"]["RequireLoginToOpen"])
          this.RequireLoginToOpen = data["env"]["RequireLoginToOpen"];
      }
      if(data["env"]["FullDelivery"])
        this.fullDelivery = data["env"]["FullDelivery"];
      if(data["env"]["AWLUnlimitedExams"])
        this.AWLUnlimited = data["env"]["AWLUnlimitedExams"];
      if(data["env"].hasOwnProperty('dopplerAutoOK'))
        this.dopplerAutoOk = data["env"]["dopplerAutoOK"];
      if(data["env"].hasOwnProperty("hasChameleon"))
        this.hasChameleon = data["env"]["hasChameleon"];
      if(data['env'].hasOwnProperty('hasFollicles'))
        this.hasFollicles = data['env']['hasFollicles'];
      if(data['env']['videoCodec'])
        this.VideoCodec = data['env']['videoCodec'];
      if(data['env']['archiveserv'])
        this.archiveServer = data['env']['archiveserv'];
      if(data['env']['anomaliesInSummary'])
        this.summaryOnlyAnamolies = data['env']['anomaliesInSummary'];
      if(data['env']['altNames'])
        this.anatomyAltNames = data['env']['altNames'];
      if(data['env']['defaultsButton'])
        this.defaultsButton = data['env']['defaultsButton'];
      if(data['env'].hasOwnProperty('smslink'))
        this.links = data['env']['smslink'];
      if(data['env'].hasOwnProperty('noprncheck'))
        this.PRNcheck = ! data['env'].noprncheck;
      if(data['env']['altSplash'])
        this.altSplashPage = data['env']['altSplash'];
      if(data['env']['hasEmergencyRoom'])
        this.hasEmergencyRoom = true;
      if(data['env']['awlExamNames'])
        this.AWLExamNames = data['env']['awlExamNames'];
      if(data['env']['altArchiveName'])
        this.altArchiveName = data['env']['altArchiveName'];
      if(data['env'].hasOwnProperty('measDefaultNone'))
        this.noneAsMeasDefault = data['env']['measDefaultNone'];
      if(data['env']['barcodeScan'])
        this.barcodeScan = data['env']['barcodeScan'];
      if(data['env']['examCodes'])
        this.ExamCodes = data['env']['examCodes'];
    }
    if(data.hasOwnProperty('hasLeumit'))
      this.hasLeumit = data.hasLeumit;
      this.isCardio = data.isCardio;
    // if(data['isCardio'])
    // else
    //   this.isCardio = false;
    if(data['isUSG'] || this.premissions)
      this.isUSG = this.premissions ? this.premissions.isUSG : data.isUSG
    else
      this.isGastro = false;
    if(this.isCardio && this.userType){
        switch(this.userType){
          case 'doctor':
            this.lastAwl = 'Completed';
          break;
          case 'tech':
            this.lastAwl = 'Received';
          break;
          case 'secretary':
            this.lastAwl = 'Waiting';
          break;
        }
    }
    this.ENVLoaded.next();
    this.hasENV = true;
  }

  sendCode(code: string){
    let req = this.http.get("api/logincode",{params:{"code": code}});
    req.subscribe((data)=>{
      if(data.hasOwnProperty("status") && data["status"] == "ok"){
        this.loginError = null;
        this.username=data["uname"];
        this.getCode=false;
        this.router.navigate(['/patsearch']);   
      }
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
      }
    },(error)=>{
      this.loginError = error.error.error;
    });
  }

  public getUserName(){
    return this.username
  }

  loginAsCurrentUser(){
    if(this.username && ! this.requireExamLogon)
      this.onLogin.next();
  }

  ldapLogin(user:string,pw: string, serv,navigate=false){
    this.http.post('http://localhost:8088/login',{login: user, 'pw': pw}).subscribe((data)=>{
      if(data.hasOwnProperty("error")){
        this.loginError = data["error"]
      }
      else{
        if(serv['location'])
          data['location'] = serv['location'];
        this.followLogin(this.http.post('/remote/login',data),navigate,user,undefined,pw);
      }
    },(err)=>{
      console.log(err);
      this.loginError = err.error.error;
    })
  }

  public getArchiveServer():string{
    return this.archiveServer;
  }

  public async Logout() {
    // Clear technician state so no previous-user data survives in the root singleton.
    this.isArtisanSupport = false;
    this.usersList = [];
    this.filteredUserSearch = [];
    this.cachedCredentials = null;
    this.twoFaAlternateMethod = null;
    this.triedTwoFaMethods.clear();
    (await this.clearCookies()).subscribe((data) => {
      this.router.navigate([""]);
      this.export$.next(false);
      this.totpVerify = false;
      this.doctor = null;
    })
  }

  async clearCookies() {
    return this.http.get("/api/login/clearCookies");
  }

  public canStartExam(hasawl: boolean):boolean{
    return this.canOpenExams && (this.ishospital || this.localServer) && (this.userType == 'doctor' || this.userType== 'tech') &&(! this.AWLOnlyExams ||  (this.AWLOnlyExams && hasawl));
  }

  public loginMissing(){
    if(! this.username)
      this.router.navigate(['/']);
  }

  public showAWL():boolean{
    return this.hasAWL && (! this.ishospital || this.userType == 'doctor' || this.userType == 'tech' || this.userType == 'secretary');
  }

  // Resolves true when the clinic was entered directly, false when an Artisan
  // technician still has to pick a user inside it.
  setClinic(id:number): Promise<boolean>{
    return new Promise((resolve, reject) => {
      const selectedGid = this.clinicOptions[id].GID;
      this.http.get('/api/setclinic/'+ selectedGid).subscribe((data)=>{
        this.ClinicID = selectedGid;
        this.Clinic = this.clinicOptions[id].ClinicTitle;
        if(this.clinicOptions[id].MarginTop || this.clinicOptions[id].MarginBottom)
          this.letterhead = true;
        this.loginError = null;
        this.http.get(`/api/login/getTOS`).subscribe((tosData) => {
          this.premissions = tosData[0];
        })
        if(this.isArtisanSupport){
          // Artisan technician: choose a user inside the clinic before entering the app.
          // clinicOptions is deliberately NOT cleared here -- the login form's *ngIf
          // keys off it, so clearing it would make the username/password fields
          // reappear underneath the user picker. It also backs "Back to Clinics".
          this.getClinicUsers(selectedGid).subscribe({
            next: (users) => {
              this.usersList = users;
              this.filteredUserSearch = users;
              resolve(false);
            },
            error: (err) => {
              this.loginError = 'Failed to load clinic users';
              reject(err);
            },
          });
          return;
        }
        this.clinicOptions = null;
        this.onLogin.next();
        this.router.navigate(['/patsearch']);
        resolve(true);
      },(error)=>{
        this.loginError = error;
        this.onFailedLogin.next();
        reject(error);
      })
    });
  }
  getUserType(){
    return this.userType;
  }

  saveHeader(formData){
    this.http.post(`/api/NewExams/setHeader/${this.CustomHeader.value ? 'y' : 'n'}`,formData).subscribe((data) => {
      console.log(data);
    })
  }

  getHeader(){
    this.http.get('/api/NewExams/getHeader' ).subscribe((data)=>{
      if(data['CustomLogo']){
        this.CustomHeader.patchValue(data['CustomLogo'])
      }
      if((data['PrintHeader'] || data['PrintHeaderCustom'] ) && ! this.ishospital && ! this.isCardio)
        this.getImageFromService();
    })
  }
  chaneHeader(){
    this.http.post('/api/NewExams/chageHeaderSetting', {CustomLogo: this.CustomHeader.value}).subscribe()
  }

  getImage(): Observable<Blob> {
    if(this.ishospital){
      if(this.CustomHeader.value){
        this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`
      }else{
        this.headerToShow = `../../assets/images/clinic.jpg`
      }
      
    }else{
      if(this.CustomHeader.value){
        return this.http.get(`/api/NewExams/getImage/y`, { responseType: 'blob' });
      }else{
        return this.http.get(`/api/NewExams/getImage/n`, { responseType: 'blob' });
      }
    }
  }
  createImageFromBlob(image: Blob) {
    // this.headerToShow = this.sanitization.bypassSecurityTrustUrl(URL.createObjectURL(image))
    let reader = new FileReader();
    reader.addEventListener("load", () => {
       this.base64 = reader.result;
      // this.headerToShow = reader.result;
      this.headerToShow = this.sanitization.bypassSecurityTrustUrl(this.base64)

    }, false);
 
    if (image) {
       reader.readAsDataURL(image);
    }
 }
 getImageFromService() {
  this.isImageLoading = true;
  if(this.ishospital){
    if(this.CustomHeader.value){
      this.headerToShow = `../../assets/images/${this.getUserName()}.jpg`
    }else{
      this.headerToShow = `../../assets/images/clinic.jpg`
    }
  }
}

  exportData(){
    this.exportLoading = true;
    return this.http.get('/api/stats/exportdata')
  }

  getTOTP(uname, pw){
    return this.http.post('/api/login/getTOTPSet', {uname:uname, pw:pw})
  }

  async completeLoginWith2FA(code: string, navigate = true){
    if(! this.cachedCredentials){
      // falls incase no login body params detected
      this.loginError = 'Please enter your username and password again.';
      return;
    }

    const { user, pw, location } = this.cachedCredentials;

    const req = this.http.post('/api/login', { user: user, pw: pw, location, twofacode: code });

    req.subscribe({
      next: (data: any) => {
        if(data && data.error){
          this.loginError = data.error;
          this.showTwoFactorInput = false;
        }else{
          this.followLogin(of(data), navigate, user, undefined, pw);
        }
      },
      error: (err) => {
        this.loginError = err.error?.error || 'An unexpected error occurred.';
      },
    });
  }

  // Re-authentication for opening/signing an exam. Hits /api/login/examlogin,
  // which skips 2FA -- the user already passed it when the session started.
  async examLogin(user: string, pw: string, location?: boolean | string, isexport: boolean = false){
    if(location){
      location = this.cachedCredentials ? this.cachedCredentials.location : undefined;
    }

    const selectedGid = this.ClinicID;
    let params: any = { user, pw, location };

    // We add the selectedGid only In case its a multi clinic configuration..
    if(Array.isArray(this.filteredClinicSearch) && this.filteredClinicSearch.length > 0 && selectedGid){
      params = { user, pw, location, selectedGid };
    }

    const loginRequest$ = this.http.post<any>('/api/login/examlogin', params);
    try{
      const response = await loginRequest$.toPromise();
      this.followLogin(of(response), false, user, isexport, pw);
    }catch(err){
      this.loginError = err.error?.error || 'An unexpected error occurred.';
      this.onFailedLogin.next();
    }
  }

  sendPasswordResetCode(username: string): Observable<any>{
    return this.http.post('/api/login/sendResetCode', { user: username });
  }

  resetPassword(username: string, code: string, newPassword: string): Observable<any>{
    return this.http.post('/api/login/resetUserPW', {
      user: username,
      newPW: newPassword,
      code: code,
    });
  }

  public async updateUserInfoAndProceed(updateInfo: {
    id: string;
    phone: string;
    email: string;
    authMode: string;
  }){
    this.loginError = ''; // Clear previous errors

    if(! this.cachedCredentials){
      this.loginError = 'Your session has expired. Please enter your username and password again.';
      throw new Error(this.loginError);
    }

    const { user, pw, location } = this.cachedCredentials;

    const payload = { user, pw, location, updateInfo };

    try{
      const response: any = await this.http.post('/api/login/updateInfo', payload).toPromise();

      if(response?.state === 'require_2fa'){
        this.twoFactorRequired.next();
      }else{
        // Case when user is not 2fa required
        this.followLogin(of(response), true, user, undefined, pw);
      }
    }catch(err){
      // The HTTP request itself failed
      this.loginError = err.error?.error || 'An unexpected error occurred while updating your information.';
      throw err;
    }
  }

  getClinicUsers(gid: number){
    return this.http.get<any[]>(`/api/admin/clinicUsers/${gid}`);
  }

  impersonateUser(uid: number){
    this.isLoginLoading = true;

    this.http.post<any>('/api/login/impersonate', { uid: uid }).subscribe({
      next: (res) => {
        this.isLoginLoading = false;
        // loginname must be the LOGIN name, as it is after a normal login where
        // this argument is the username that was typed. res.uname is the display
        // name -- followLogin already stores that separately as this.username.
        // Passing it here made the exam-login box prefill a display name, which
        // 401s, and made its `loginname != user` guard impossible to satisfy.
        // Falls back to uname so an older API still logs the user in.
        this.followLogin(of(res), true, res.loginName || res.uname, false);
      },
      error: (err) => {
        this.isLoginLoading = false;
        this.loginError = err.error?.error || 'Impersonation failed';
      },
    });
  }

  // A send failed. Explain which channel, and offer the other one if it has not
  // been tried yet. When both are exhausted, twoFaAlternateMethod is null and the
  // message points the user at support.
  private handle2FASendFailure(data: any){
    const attempted = data['attemptedMethod'];
    const alternate = data['alternateMethod'];
    if(attempted)
      this.triedTwoFaMethods.add(attempted);
    const canTryAlternate = alternate && ! this.triedTwoFaMethods.has(alternate);
    this.twoFaAlternateMethod = canTryAlternate ? alternate : null;
    this.loginError = this.compose2FASendError(attempted, this.twoFaAlternateMethod);
  }

  private compose2FASendError(attempted: string, alternate: string | null): string{
    const label = (m: string) => (m === 'sms' ? 'SMS' : 'WhatsApp');
    if(alternate)
      return `We couldn't send your verification code by ${label(attempted)}. `
        + `You can try ${label(alternate)} instead - or contact support if the problem continues.`;
    return `We couldn't reach you by SMS or WhatsApp. `
      + `Please contact support so we can get you signed in.`;
  }

  // Retry the send over the chosen channel. Success opens the 2FA panel; another
  // failure re-runs the same handler, which now offers support instead of a button.
  retry2FAWith(method: 'sms' | 'whatsapp'){
    this.isLoginLoading = true;
    this.twoFaAlternateMethod = null; // hide the button while the attempt is in flight
    this.requestResend2FACode(method).subscribe((res: any) => {
      this.isLoginLoading = false;
      if(res && res['state'] === 'require_2fa'){
        this.loginError = null;
        this.twoFactorRequired.next();
      }else if(res && res['status'] === 'fail' && res['twofaSendFailed']){
        this.handle2FASendFailure(res);
      }else if(res && res['error']){
        this.loginError = res['error'];
      }
    }, (error) => {
      this.isLoginLoading = false;
      this.loginError = error?.error?.error || 'We couldn\'t send the code. Please contact support.';
    });
  }

  requestResend2FACode(method: 'whatsapp' | 'sms'): Observable<any>{
    const { user, pw, location } = this.cachedCredentials;
    return this.http.post('/api/login', {
      user: user,
      pw: pw,
      resend2FA: true,
      location: location,
      '2faMethod': method, // method type (whatsapp or sms)
    });
  }

  getDocByUID(uid:number){
    for(let usr of this.clinicUsers){
      if(usr.UID == uid)
        return usr.Name;
    }
    return '';
  }

  getLimits(){
    this.http.get('/api/limits').subscribe((data) =>{
      this.limits = data;
    })
  }

  countLinks(){
    this.http.get('/api/NewExams/countLinks').subscribe((data:any) =>{
      this.linksent = data;
    })
  }
  
}
